module.exports = __webpack_public_path__ + "img/empty-placeholder.ef9424dd.png";